const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CNY: '\u00a5',
  HKD: 'HK$',
};

export const SUPPORTED_CURRENCIES = ['USD', 'CNY', 'HKD'] as const;

export function formatPrice(amount: number, currency = 'USD'): string {
  const symbol = CURRENCY_SYMBOLS[currency] || currency + ' ';
  return `${symbol}${amount.toFixed(2)}`;
}

export function getCurrencySymbol(currency = 'USD'): string {
  return CURRENCY_SYMBOLS[currency] || currency + ' ';
}
